import { User } from "lucide-react";
import React from "react";

export default function UserPointsCard() {
  return (
    <div className="space-y-4 h-96">
      <h1 className="text-3xl text-white font-semibold">Team Members</h1>
      {/* <div class="border-2 border-[rgba(251,209,80,0.2)]"></div> */}
      <div className="flex w-full max-sm:justify-center items-center">
        {" "}
        <div className="w-56 h-40 bg-[linear-gradient(130.82deg,#0F131A_0%,#171D26_100%)] rounded-lg shadow-[0_8px_32px_0_#05070A4D] flex flex-col justify-center items-center ">
          <div className="relative w-16 h-16 rounded-full bg-gradient-to-tr from-[#222a3a] to-[#1a2029] flex justify-center items-center border-2 border-[rgba(251,209,80,0.2)]">
            <User className="w-6 h-6 text-white" />
            <div className="absolute bottom-0 translate-y-1/2 bg-[#FBD150] w-8 h-4 rounded-lg flex justify-center items-center text-sm font-semibold">
              #1
            </div>
          </div>
          <div className="space-y-1 mt-3 text-center">
            <h1 className="text-white font-semibold">Alex Johnson</h1>
            <p className="text-[#9DA6AF] text-sm">15,420 pts</p>
          </div>
        </div>
      </div>
    </div>
  );
}
